import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { BackHistoryStorage } from '../utils/helpers/BackHistoryStorage';

const useBackHistoryStorage = () => {
  const router = useRouter();

  const routeChangeStartHandler = useRef(null);

  useEffect(() => {
    routeChangeStartHandler.current = () => {
      BackHistoryStorage.setBackHistoryStorage();

      const initialPath = BackHistoryStorage.getBackHistoryStorageInitialPath();
      if (!initialPath) {
        BackHistoryStorage.setBackHistoryStorageInitialPath(
          window?.location?.pathname
        );
      }
    };

    router.events.on('routeChangeStart', routeChangeStartHandler.current);

    return () => {
      router.events.off('routeChangeStart', routeChangeStartHandler.current);
    };
  }, [router.events]);

  useEffect(() => {
    const handleHistoryBackEvent = () => {
      const initialPath = BackHistoryStorage.getBackHistoryStorageInitialPath();

      if (initialPath === window?.location?.pathname) {
        BackHistoryStorage.removeBackHistoryStorage();
      }
    };

    window.addEventListener('popstate', handleHistoryBackEvent);

    return () => {
      window.removeEventListener('popstate', handleHistoryBackEvent);
    };
  }, []);
};

export default useBackHistoryStorage;
